module.exports = __webpack_public_path__ + "static/media/alunna.bee68b08.svg";